import Vue from 'vue';

const defaultState = {
    client: {},
};

const mutations = {
    // Client in the URL
    setClientState(state, client) {
        Vue.set(state, 'client', client);
    },
    resetClientState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getClientInfo({ commit, dispatch }, clientId) {
        try {
            const { data } = await this.$rq.getClientInfo(clientId);
            commit('setClientState', data);
        } catch (err) {
            dispatch('resetClientInfo');
        }
    },
    resetClientInfo({ commit }) {
        commit('resetClientState');
    },
};

const getters = {
    client: state => state.client,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
